import { calendarLoader } from "./libs/calendar.js";

document.addEventListener("DOMContentLoaded", calendarLoader, false);
